import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * **High-Level Software**
 *
 * @exports bs_343
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};
  let refreshBooking;
  const usersWithMultipleBookings = [1043355];
  /**
     * @memberOf module:bs_343
     * @see {@link is_user_logged}
     *
     * @param {object} ctx - The context object.
     */

  engine.isUserLogged = function isUserLogged(ctx) {

    return !((document.querySelector('.button.default') || {}).textContent || '').match(/Login/);
  };

  /**
     * @memberOf module:bs_343
     * @see {@link prestart}
     *
     * @param {object} ctx - The context object.
     */
  engine.boot = function boot(ctx) {

    const container = document.querySelector('.room');
    if (container && !thn.hlRefreshPage) {
      thn.hlRefreshPage = thn.debounce(function () {
        thn.pageCheck();
        if (thn.data.pageName === 'Rooms and Rates') {
          thn.widgets.price.refresh();
        }
      }, 300);
      thn.observeDom(container, thn.hlRefreshPage, {
        childList: true,
        subTree: true,
        attributes: false,
      });
      thn.shutdown(() => {
        thn.hlRefreshPage.cancel();
        thn.stopObserveDom(container, thn.hlRefreshPage);
        delete thn.hlRefreshPage;
      });
    }

    window.thnHighLevelSoftwareApplyPromocode = function thnHighLevelSoftwareApplyPromocode(data) {
      if (thn.data.pageName === 'Rooms and Rates') {
        const promoButton = document.querySelector('[data-cy=open-add-voucher]');
        if (promoButton) {
          promoButton.click();
          setTimeout(() => {
            const promoInput = document.querySelector('#input-code');
            const promoSubmit = document.querySelector('[data-action=addDiscount]');
            if (promoInput && promoSubmit) {
              promoInput.value = data.code;
              promoSubmit.click();
            }
          }, 700);
        }
      } else {
        const url = new URL(document.querySelector('a[href^="https://live.high-level-software.com"]')?.href);
        url.pathname = `${url.pathname}/apply-voucher/${data.code}`;
        setTimeout(() => {
          window.location.href = url.toString();
        }, 300);
      }
    };

    thn.shutdown(() => {
      delete window.thnHighLevelSoftwareApplyPromocode;
    });
  };

  /**
     * @memberOf module:bs_343
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {

    // https://live.high-level-software.com/hotels/pp-the-bear-and-ragged-staff/availability
    const url = new URL(ctx.baseUrl);
    const validUrl = url.pathname.match(/availability/);

    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }

    // Export into ctx.newUrl
    ctx.newUrl = url.toString();

    return ctx;
  };

  /**
     * @memberOf module:bs_343
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};

    // Dates
    const dateBegin = document.querySelector('#dateFrom')?.value?.replace(/-/g, '/');
    const dateEnd = document.querySelector('#dateTo')?.value?.replace(/-/g, '/');
    let nights;
    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin;
      widgetData.dateEnd = dateEnd;
      nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
    }

    const occupancy = Array.from(document.querySelector('.selector.select-occupancy > div.sub-selected > span')?.textContent?.split('&'));
    const adults = thn.parseNumber(occupancy[0]) || 2;
    const children = thn.parseNumber(occupancy[1]) || 0;
    let prices;
    const allRooms = [...document.querySelectorAll('.room')].map((room) => {
      // for each type of room in the view
      prices = [...room.querySelectorAll('[class*=rate-price]:not([class*=show-for]) .value')].map((el) => thn.parseNumber(el.textContent));
      prices.sort((a, b) => a - b);
      if (thn.empty(prices)) {
        return false;
      }
      return {
        price: prices[0],
      };
    }).filter(Boolean);
    allRooms.sort((a, b) => a.price - b.price);

    const cheapestRoom = allRooms[0];
    const noAvailability = document.querySelector('.message-banner.warning.text-center');

    widgetData.adults = adults;
    widgetData.children = children;
    widgetData.guests = widgetData.adults + widgetData.children;

    if (cheapestRoom?.price && nights) {
      widgetData.price = (cheapestRoom.price / nights).toFixed(2);
      widgetData.currency = thn.parseCurrency((document.querySelector('[class*=rate-price]:not([class*=show-for])') || {}).textContent) || 'GBP';
      thn.engine._roomDetailsParseData(thn.parseNumber(occupancy[0]), thn.parseNumber(occupancy[1]), nights);
      widgetData.set = true;
    } else if (noAvailability || (!cheapestRoom && nights)) {
      widgetData.noRooms = true;
    }
    return widgetData;
  };

  /**
     *
     * @memberOf module:bs_343
     *
     */
  engine._roomDetailsParseData = function roomDetailsParseData(adults, children, nights) {
    const roomDetailsArray = [];
    const roomSelector = document.querySelectorAll('.room');
    if (roomSelector.length) {
      roomSelector.forEach(function (element) {
        const roomName = (element.querySelector('.room-name > h4') || {}).innerText || '';
        const roomData = {
          id: '',
          name: roomName,
          adults: adults,
          children: children,
          nights: nights,
          prices: [],
        };
        if (roomName.match(/S?s?ignature/i)) {
          roomData.type = 'signature';
        } else if (roomName.match(/S?s?uperior/i)) {
          roomData.type = 'superior';
        } else {
          roomData.type = '';
        }
        const rateElements = element.querySelectorAll('.rate');
        rateElements.forEach(function (rateElement) {
          const priceItemName = (rateElement.querySelector('h5.rate-name') || {}).innerText;
          const price = thn.parseNumber((rateElement.querySelector('.rate-price > span') || {}).textContent);
          const priceData = {
            id: '',
            name: priceItemName,
            totalNight: price / nights,
            refundable: 1, // All rooms are refundable
          };
          roomData.prices.push(priceData);
        });
        roomDetailsArray.push(roomData);
      });
    }
    return roomDetailsArray;
  };

  /**
    * @memberOf module:bs_343
    * @this thn.widgets.booking
    * @see {@link Booking#observe_dom}
    *
    * @param {object} ctx - The context object.
    */
  engine.bookingObserveDom = function bookingObserveDom(ctx) {
    const container = document.querySelector('main');

    if (container && !refreshBooking && !ctx.widget.isSet()) {
      refreshBooking = thn.debounce(() => {
        if (ctx.widget.setData.isSet()) {
          ctx.widget.save();
        }
      });

      thn.observeDom(container, refreshBooking, {
        childList: true,
        subTree: true,
        attributes: false,
      });

      thn.pageUnload(() => {
        refreshBooking.cancel();
        thn.stopObserveDom(container, refreshBooking);
        refreshBooking = null;
      });
    }
  };

  /**
     * @memberOf module:bs_343
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};

    const bookingId = document.querySelector('[data-cy="booking_reference"]')?.textContent;

    if (!bookingId) {
      widgetData.set = false;
      return widgetData;
    }

    widgetData.bookingId = bookingId;
    const bookingInfoFromDl = thn.dataLayerHelper.get('ecommerce');
    let isMultiBooking = false;

    if (bookingInfoFromDl) {
      // purchase event doesn't have bookingId
      thn.logger.debug('Saving data from purchase event in dataLayer', window.dataLayer);
      const bookingItems = bookingInfoFromDl.items;
      isMultiBooking = bookingItems.length > 1 && usersWithMultipleBookings.includes(thn.data.userId);

      if (isMultiBooking) {
        thn.logger.debug('Saving data from multi booking in dataLayer');
        const widgetDataMulti = bookingItems.map((item) => ({
          bookingId: `${bookingId}-${item.index}`,
          dateBegin: item.check_in?.replace(/-/g, '/'),
          dateEnd: item.check_out?.replace(/-/g, '/'),
          currency: item.currency,
          price: thn.parseNumber(item.price),
          promocode: bookingInfoFromDl.coupon,
        }));

        return widgetDataMulti;
      }

      widgetData.dateBegin = bookingInfoFromDl.items?.[0]?.check_in?.replace(/-/g, '/');
      widgetData.dateEnd = bookingInfoFromDl.items?.[0]?.check_out?.replace(/-/g, '/');
      widgetData.currency = bookingInfoFromDl.currency;
      widgetData.price = thn.parseNumber(bookingInfoFromDl.value);
      widgetData.promocode = bookingInfoFromDl.coupon;

      return widgetData;
    }

    const reservationElms = [...document.querySelectorAll('.reservation')];
    isMultiBooking = reservationElms.length > 1 && usersWithMultipleBookings.includes(thn.data.userId);

    if (isMultiBooking) {
      const widgetDataMulti = reservationElms.map((reservationElm, index) => {
        const datesFromDom = reservationElm.querySelector('.dates')?.textContent?.trim().split('-');
        const nights = thn.parseNumber(reservationElm.querySelector('.dates .right')?.textContent);
        const dateBegin = datesFromDom?.[0] && translateDate(datesFromDom?.[0], thn.data.language);

        return {
          bookingId: `${bookingId}-${index}`,
          dateBegin: dateBegin,
          dateEnd: thn.dateToString(thn.addDays(dateBegin, nights)),
          price: thn.parseNumber(reservationElm.querySelector('.room-rate span')?.textContent),
          currency: thn.parseCurrency(reservationElm.querySelector('.room-rate span')?.textContent),
        };
      });

      return widgetDataMulti;
    }

    const datesFromDom = document.querySelector('.reservation .dates')?.textContent?.trim().split('-');
    const nights = thn.parseNumber(document.querySelector('.dates .right')?.textContent);
    const dateBegin = datesFromDom?.[0] && translateDate(datesFromDom?.[0], thn.data.language);

    // datesFromDom has format "dd MMM yyyy - dd MMM"
    if (dateBegin && nights) {
      widgetData.dateBegin = dateBegin;
      widgetData.dateEnd = thn.dateToString(thn.addDays(dateBegin, nights));
    }

    widgetData.price = thn.parseNumber(document.querySelector('[data-cy="total-price"]')?.textContent);
    widgetData.currency = thn.parseCurrency(document.querySelector('[data-cy="total-price"]')?.textContent);

    return widgetData;
  };

  engine.getPromocode = function getPromocode(ctx) {
    const promcodeEl = document.querySelector('[data-element=voucher]');
    // if element exists promocode is applied
    if (promcodeEl) {
      ctx.promocode = '_unknown_';
    }
    return ctx;
  };

  return engine;

}

export { factory };
